function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.47429 0.542523C9.19765 1.26589 9.19765 2.43869 8.47429 3.16206L5.36403 6.27232C4.96214 6.67421 4.96214 7.3258 5.36403 7.72769L8.47429 10.8379C9.19765 11.5613 9.19765 12.7341 8.47429 13.4575C7.75093 14.1808 6.57812 14.1808 5.85476 13.4575L1.61649 9.21921C0.390856 7.99358 0.390858 6.00642 1.6165 4.78079C3.02925 3.36803 4.442 1.95528 5.85476 0.542524C6.57812 -0.180841 7.75093 -0.180841 8.47429 0.542523Z",
  fill: "black",
  fillOpacity: 0.3
});

function SvgLeftArrowSoft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowSoft);
export default __webpack_public_path__ + "static/media/left-arrow-soft.21a28b5f.svg";
export { ForwardRef as ReactComponent };